export default {
  'notAuth.title': 'Yetkili değilsiniz!',
  'notAuth.toHome': 'Anasayfaya Dön',
  'notAuth.desc':
    'Ulaşmaya çalıştığınız sayfayı görüntüleme yetkiniz yok. Lütfen sistem yöneticiniz ile iletişime geçin.',
};
